module.exports = __webpack_public_path__ + "img/down-gx2.3d9fab93.jpg";